<template>
  <div>
    <TopAppBar
      :title="memberDetail ? memberDetail.brandName : null"
      :hideCategory="false"
      staticMode="true"
    >
    </TopAppBar>
    <div class="container main-wrapper d-flex justify-content-center">
      <TopAppBarDrawer class="subject-drawer-wrapper"></TopAppBarDrawer>

      <div class="w-full pdb-50 container--narrow">
        <div class="container pdt-50">
          <div class="t-color-headlineBlack t-headline15 font-b">
            {{ subjectTitle.title }}
          </div>
          <div class="divider mgt-24 mgb-24"></div>
        </div>

        <NoData
          class=""
          v-if="isNoData"
          :msgData="{ msg1: '3206', msg2: '3207' }"
        ></NoData>

        <div v-else>
          <div v-for="(degree, index) in responseData" :key="index">
            <MicroListItem
              v-if="isMicro"
              :degree="degree"
              :status="degree.progressViewStatus"
              @initProgressStatus="initProgressStatus"
            />
            <ListItem
              v-else
              :degree="degree"
              :status="degree.progressViewStatus"
              @initProgressStatus="initProgressStatus"
            />
          </div>

          <paginate
            v-model="currentPage"
            :click-handler="handlePaging"
            :container-class="'pagination'"
            :next-text="'<span class=material-icons >keyboard_arrow_right'"
            :page-class="'pagination-item'"
            :page-count="totalPages"
            :page-range="5"
            :prev-text="'<span class=material-icons >keyboard_arrow_left'"
          >
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

import { mapState } from "vuex";

import learnApi from "@/api/learnApi.js";
import microLearnApi from "@/api/microLearnApi.js";

export default {
  name: "Subject",
  components: {
    swiper,
    swiperSlide,
    TopAppBar: () => import("@/components/TopAppBar.vue"),
    TopAppBarDrawer: () => import("@/components/TopAppBarDrawer.vue"),
    NoData: () => import("@/components/common/NoData.vue"),
    ListItem: () => import("@/components/learn/ListItem.vue"),
    MicroListItem: () => import("@/components/microLearn/ListItem.vue"),
  },
  data() {
    return {
      subjectId: null,
      isNoData: false,
      responseData: null,
      subjectTitle: "",
      subjectDegreeData: [],
      leftBtnMethod: () => {
        this.$router.go(-1);
      },
      degreeCategorys: [],
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 20,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        translate: 0,
        autoHeight: false,
      },
      isMicro: this.$route.query.type && this.$route.query.type === "MICRO",

      currentPage: 1,
      totalPages: 1,
    };
  },
  computed: {
    // swiper define
    swiper() {
      return this.$refs.mySwiper.swiper;
    },

    ...mapState({
      memberDetail: (state) => state.member.memberDetail,
    }),
  },

  created() {
    this.subjectId = this.$router.currentRoute.params.id;
    this.subjectTitle = this.$route.query;
    this.fetchData();
  },

  methods: {
    async fetchData() {
      const params = {
        page: this.currentPage,
        size: 10,
        subject: this.subjectId,
        status: "LEARNING",
        sort: "desc",
      };

      try {
        const result = this.isMicro
          ? await microLearnApi.subjectList(params)
          : await learnApi.fetchList(params);
        const datas = result.data.data;
        this.totalPages = datas.totalPages;
        this.responseData = datas.content.map((val) => {
          console.log(val);
          val.progressViewStatus = false;
          return val;
        });

        this.isNoData = !datas || this.responseData.length === 0;
      } catch (error) {
        console.log("GET ONLINE CLASS DATA ERROR : ", error);
      }
    },

    // 파라미터 설정(set parameter)
    setParams(subjectId) {
      const params = {
        sort: "desc",
        page: 1,
        size: 10,
        subjectId: subjectId,
      };
      return params;
    },

    initProgressStatus(id) {
      this.responseData = this.responseData.map((val) => {
        val.progressViewStatus =
          val.id === id && val.progressViewStatus === false;
        return val;
      });
    },

    handlePaging(e) {
      this.currentPage = e;
      this.fetchData();
    },
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 48px 24px;
}
.subject-drawer-wrapper {
  margin-top: -68px;
}
</style>